
import React, {useEffect,useReducer,useState, useRef, FormEvent} from 'react';
import {Buffer} from 'buffer';
import useGoogleCaptcha from '../../components/useReCaptcha.js';

import FlashMessages from '../../components/flashMessages.js';

import {DomainRemovalPageResult} from '../../../../server/routes/domain-removal.js'

// Global declarations
declare global {
    interface Window {
        //grecaptcha: wts_approved_any;
        $: wts_approved_any;
    }
    //const grecaptcha: wts_approved_any;
    //const $: wts_approved_any;
}

interface RemoveDomainProps {
    server: string;
    pageData: unknown;
}

interface RemovalFormProps {
    reCaptchaSiteKey: string;
    props: DomainRemovalPageResult;
    google: wts_approved_any;
}

interface ErrorState {
    title: string;
    description: string;
    active: boolean;
}

interface RemovalFormState {
    error: ErrorState;
}

interface ApiResponse {
    success?: boolean;
    success_msg?: string;
    errors?: Array<{ msg: string }>;
}

type RemovalFormAction = 
    | ["error", { title?: string; description?: string; active?: boolean }]
    | ["success", { title?: string; description?: string; active?: boolean }];

export default function RemoveDomain({server, pageData}: RemoveDomainProps) {

    const typedPageData = pageData as DomainRemovalPageResult;
	let [data, setData] = useState(typedPageData);
    const google = useGoogleCaptcha();

	return (
        <div  className={ "app" }>
             <section className="section section-lg reports-body">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-2 col-lg-2 col-xl-2">
                        </div>      
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <h3 className="text-left mb-3">
                                <b>
                                    Domain removal
                                </b>
                            </h3>
                            <p>
                            You can request to remove your domain from our dataset. When requesting domain
                             removal from our data, we might require you to verify that you control the 
                             domain you're requesting to be removed. To show you control the domain, 
                             please provide your domain name below, upload a <i>wts.txt</i> text file containing provided verification code
                            to your website root web directory and then click on remove domain button.

                            </p>
                        </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-2 col-lg-2 col-xl-2">
                        </div>   
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <RemovalForm   
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey} 
                                google={google}
                                /> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </div>
    )
}



const RemovalFormReducer = function( state: RemovalFormState, [ type, data ]: RemovalFormAction ): RemovalFormState {
    if( type === "error" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};   
    if( type === "success" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};
    return state; 
};
function RemovalForm({reCaptchaSiteKey, props, google}: RemovalFormProps) {
	const [ state, dispatch ] = useReducer( RemovalFormReducer, {
        error: { title: "", description: "", active: false }
      
    });
    useEffect(() => { 
		return () => {
			let script = document.getElementById('googleCaptchaScript');
			if (script) {
				script.remove();
			}
		}				
	},[google])       

    let domainControl = useRef<HTMLInputElement>(null);
    let codeControl = useRef<HTMLInputElement>(null);
    let clipboardControl = useRef<HTMLSpanElement>(null);
    let locationControl = useRef<HTMLInputElement>(null);

    function generateCode() {
        if (!domainControl.current || !codeControl.current || !locationControl.current) return;
        let domain = domainControl.current.value;
        if (domain && domain.length > 0) {
            var regExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)(?:.*)?$/g;
            var match = regExp.exec(domain.trim());
            if (match !== null) {
                domain = match[1];
                let buff = Buffer.from(domain).toString('base64')
                console.log(buff);
                codeControl.current.value = buff;
                locationControl.current.value = "https://" + domain + "/wts.txt";                
                $("span").css("pointer-events", "auto");
                $("span").css("color", "black");
            } else {
                codeControl.current.value = '';  
                locationControl.current.value = '';   
                $("span").css("pointer-events", "none");
                $("span").css("color", "gray");
            }
        } else {
            codeControl.current.value = '';
            locationControl.current.value = '';      
            $("span").css("pointer-events", "none");
            $("span").css("color", "gray");
        }  
    }
    function clickEye() {
        if (!codeControl.current) return;
        navigator.clipboard.writeText(codeControl.current.value);
    }
    function Send ( email: string, domain: string, captcha: string){
        var requestBody = JSON.stringify({email, domain, captcha});
    
        fetch( "/domain-removal/send", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then(( result: Response ) => {
            return result.json();
        }).then(( data: ApiResponse ) => {
            if (data.success) { 
                console.log(JSON.stringify(data));
                dispatch([ "success", {
                    title: "Success",
                    description: data.success_msg
                }]);  
            } else {
                console.log(JSON.stringify(data));
                var msg = "Unknown error"
                if (data.errors && data.errors.length > 0)
                {
                    msg = data.errors[0].msg
                }
                dispatch([ "error", {
                    title: "Failure",
                    description: msg
                }]);  
            }
            grecaptcha.reset();
    
        }).catch(( e ) => {
            console.error( "Exception", e );
        });
    
    };   
    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        const captcha = grecaptcha.getResponse();
        const form = event.currentTarget;
        const emailElement = form.elements.namedItem('email') as HTMLInputElement;
        const domainElement = form.elements.namedItem('domain') as HTMLInputElement;
        
        Send(
            emailElement.value,
            domainElement.value,
            captcha)
      }   
    return (      
        <>    
        <div className={ "error" + (state.error.active ? " " : " hidden") }>
            <div className={ "error-close" } onClick={() => dispatch([ "error", { active: false } ]) }>X</div>
            <div className={ "error-title" }>{ state.error.title }</div>
            <div className={ "error-description" }>{ state.error.description }
        </div>
    </div>  
        <form id='removalform' action="/domain-removal" method="POST"  onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={props} />
            </div>
            <div className="form-group">
            <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    aria-label="Email"
                    placeholder="Enter Email"
                    required
                />                
            </div>           
            <div className="form-group">
                <label htmlFor="domain">Your domain name</label>
                <input
                    type="text"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Domain"
                    placeholder="Your domain name"
                    required
                    onChange={generateCode}
                    ref={domainControl}
                />                
            </div>
            <div className="form-group">
                <label htmlFor="removalcode">Removal code to paste in <i>wts.txt</i> text file</label>
                <div className="wts-pass-show">               
                    <input
                        type="text"
                        readOnly
                        id="removalcode"
                        name="removalcode"
                        className="form-control"
                        aria-label="Removal Code"
                        placeholder="Removal Code"
                        ref={codeControl}
                    />   
                    <span className="wts-pass-text" ref={clipboardControl}
                        style={{ pointerEvents: 'none', color: 'gray'}}>
                        <i                  
                            onClick={clickEye}
                            className="mdi mdi-content-copy" 
                            aria-disabled="true"
                        />
                    </span>   
                </div>                         
            </div>
            <div className="form-group">
            <label htmlFor="locationUri">Text file location on your website we'll use for domain validation</label>
            <input
                    type="text"
                    readOnly
                    id="locationUri"
                    className="form-control"
                    aria-label="Location URI"
                    placeholder="Location URI"
                    ref={locationControl}
                />                
            </div>
            <div className="form-group" style={{ display: "flex" }}>
                            <div style={{ marginLeft: 'auto'}}
                                className="g-recaptcha" 
                                id="captcha1"
                                data-sitekey={reCaptchaSiteKey}>
                            </div>
            </div>             
             <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Remove Domain</button>
            </div>
        </form>    
    </>
   )
}
